import React from 'react';
import { humanizeKey } from '../../profile-explanation-utils';

interface ISectionProps {
    title: string;
    children: React.ReactNode;
    titleExtra?: React.ReactNode;
}

const Section: React.FC<ISectionProps> = ({ title, children, titleExtra }) => (
    <div className="profile-explanation-section">
        <div className="profile-explanation-section-header">
            <h5 className="profile-explanation-section-title">{humanizeKey(title)}</h5>
            {titleExtra && <div className="profile-explanation-section-title-extra">{titleExtra}</div>}
        </div>
        <div className="profile-explanation-section-content">{children}</div>
    </div>
);

export default Section;
